const state = {
  readingImages: 0,
  readingImagesLength: 0,
  generatingZipProgress: {},
  uploadProgress: {},
  filesMBSize: 0,
  filesMBLimit: 0,
};

const getters = {};

const actions = {
  readingImages({ commit }, payload) {
    commit("readingImages", payload);
  },
  readingImagesLength({ commit }, payload) {
    commit("readingImagesLength", payload);
  },
  generatingZipProgress({ commit }, payload) {
    commit("generatingZipProgress", payload);
  },
  uploadProgress({ commit }, payload) {
    commit("uploadProgress", payload);
  },
  filesMBSize({ commit }, payload) {
    commit("filesMBSize", payload);
  },
  filesMBLimit({ commit }, payload) {
    commit("filesMBLimit", payload);
  },
};

const mutations = {
  readingImages(state, payload) {
    state.readingImages = payload;
  },
  readingImagesLength(state, payload) {
    state.readingImagesLength = payload;
  },
  generatingZipProgress(state, payload) {
    state.generatingZipProgress = payload;
  },
  uploadProgress(state, payload) {
    state.uploadProgress = payload;
  },
  filesMBSize(state, payload) {
    if (payload == 0) {
      state.filesMBSize = 0;
    } else state.filesMBSize += payload;
  },
  filesMBLimit(state, payload) {
    if (payload == 0) {
      state.filesMBLimit = 0;
    } else state.filesMBLimit += payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
